import { functions, httpsCallable } from '@/firebase';
import { consequenceTypesService } from './consequenceTypesService';
import { mentionTypesService } from './mentionTypesService';

const commit = httpsCallable(functions, 'commitProtectedDomainDefinitionConfiguration');

export async function commitProtectedDomainDefinitionConfiguration(request) {
  const result = (await commit(request)).data;
  consequenceTypesService.clearCache();
  mentionTypesService.clearCache();
  return result;
}
